import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SearchResultsHeader = ({ 
  searchQuery, 
  resultsCount, 
  onClearSearch, 
  isLoading 
}) => {
  return (
    <div className="bg-card border-b border-border px-6 py-4">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        {/* Search Context */}
        <div className="flex items-center space-x-3">
          <div className="flex items-center space-x-2">
            <Icon name="Search" size={20} className="text-muted-foreground" />
            <h1 className="text-xl font-semibold text-foreground">
              Search Results
            </h1>
          </div>
          {searchQuery && (
            <div className="flex items-center space-x-2">
              <span className="text-muted-foreground">for</span>
              <span className="px-2 py-1 bg-muted rounded-md text-sm font-medium text-foreground">
                "{searchQuery}"
              </span>
            </div>
          )}
        </div>

        {/* Results Count & Actions */}
        <div className="flex items-center space-x-4">
          {!isLoading && (
            <div className="text-sm text-muted-foreground">
              {resultsCount === 0 ? (
                "No clients found"
              ) : resultsCount === 1 ? (
                "1 client found"
              ) : (
                `${resultsCount} clients found`
              )}
            </div>
          )}
          
          {searchQuery && (
            <Button
              variant="outline"
              size="sm"
              onClick={onClearSearch}
              iconName="X"
              iconPosition="left"
              iconSize={16}
              className="transition-all duration-150 hover:bg-destructive hover:text-destructive-foreground hover:border-destructive"
            >
              Clear Search
            </Button>
          )}
        </div>
      </div>

      {/* Loading Indicator */}
      {isLoading && (
        <div className="mt-4 flex items-center space-x-2 text-muted-foreground">
          <div className="animate-spin w-4 h-4 border-2 border-primary border-t-transparent rounded-full"></div>
          <span className="text-sm">Searching clients...</span>
        </div>
      )}
    </div>
  );
};

export default SearchResultsHeader;